import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('input', 'input', 'autocomplete')`
    ${propStyles};
    &::placeholder {
        color: currentColor;
    }
`;
StyledComponent.defaultProps = {
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
    outline: 'none',
    borderStyle: 'none',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/Input.tsx